import { render, staticRenderFns } from "./zhpIndex.vue?vue&type=template&id=287d9c93&scoped=true&"
import script from "./zhpIndex.vue?vue&type=script&lang=js&"
export * from "./zhpIndex.vue?vue&type=script&lang=js&"
import style0 from "./zhpIndex.vue?vue&type=style&index=0&id=287d9c93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d9c93",
  null
  
)

export default component.exports